import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function NotVisibleP1DoorHangerPage({ navigation }) {
  const [details, setDetails] = useState({
    not_visible_p1_door_hanger_description: "",
    door_hanger_unvisible_reason: "",
    other_reason_p1_door_hanger_not_visible: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    newErrors.door_hanger_unvisible_reason = !details.door_hanger_unvisible_reason;
    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleSubmit = () => {
    if (validate()) {
      // Navigate to QRPH Door Sticker Merch step
      try {
        localStorage.setItem( 'p1-not-visible');
      } catch (e) {
        // ignore storage errors
      }
      navigation.go('p1-door-sticker-merchandising');
    }
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">NOT VISIBLE P1 DOOR HANGER</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">

              <Form>

                  {/* Reason P1 door hanger not visible */}
                  <Form.Group className={`mb-4 ${errors.door_hanger_unvisible_reason ? 'form-group-error' : ''}`}>
                    <Form.Label className="form-label">
                      Reason P1 door hanger not visible <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "HO restriction",
                        "mall restriction",
                        "no Maya customers",
                        "P1/Terminal has been pulled out",
                        "clean store policy",
                        "P1/Terminal is not used/boxed",
                        "missing",
                        "no P1 door hanger",
                        "other reason"
                      ].map((reason) => (
                        <div key={reason} className={`form-radio-item${details.door_hanger_unvisible_reason === reason ? " selected" : ""}`}>
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="door_hanger_unvisible_reason"
                              value={reason}
                              label={reason}
                              checked={details.door_hanger_unvisible_reason === reason}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.door_hanger_unvisible_reason && (
                      <div className="form-error">
                        Required
                      </div>
                    )}
                  </Form.Group>

                  {/* Other reason P1 door hanger not visible */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Other reason P1 door hanger not visible
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="other_reason_p1_door_hanger_not_visible"
                      value={details.other_reason_p1_door_hanger_not_visible || ''}
                      onChange={handleChange}
                      placeholder="Short answer text"
                      className="form-input"
                    />
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={navigation.previous}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                     Next → 
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotVisibleP1DoorHangerPage;
